import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isMobile, getInstrumentIcon } from "../../../../utils";
import SVGInline from "react-svg-inline";
import arrowSideSVG from "../../../inlineSVGs/arrowSideSVG";

import './PlayingOnStageSlider.css';
import {LANG} from "../../../../locale";

class PlayingOnStageSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.subCatScrollerRef = {};
    }

    scrollSubCat(side) {
        if (!this.subCatScrollerRef) return;

        if (side === 'left') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: -300,
                behavior: 'smooth'
            });

            return;
        }

        if (side === 'right') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: 300,
                behavior: 'smooth'
            });
        }
    }

    renderInstruments() {
        if (!this.props.datatypes.instruments) return null;

        const selected = this.props.selected || [];

        return this.props.datatypes.instruments.map((instrument, index) => {
            const isSelected = selected.indexOf(instrument.name) > -1;

            return (
                <div className="instrument" key={index}>
                    <img src={getInstrumentIcon(instrument.name)}
                         alt="instrument"
                         style={{display: !isSelected ? 'inline-flex' : 'none' }}
                         onClick={()=> this.props.selectInstrument(instrument.name)}
                    />
                    <img src={getInstrumentIcon(instrument.name, true)}
                         alt="instruments"
                         style={{display: isSelected ? 'inline-flex' : 'none' }}
                         onClick={() => this.props.unSelectInstrument(instrument.name)}
                    />
                    <label
                        className={`instrument-name ${ isSelected ? 'selected' : '' }`}
                        style={{color: isSelected ? instrument.color : ''}}
                    >
                        {LANG === 'he' ? instrument.he : instrument.text}
                    </label>
                </div>
            )
        });
    }

    render() {
        if (!this.props || !this.props.type || !this.props.datatypes) return null;

        // Playing on stage
        return (
            <div className="playing-on-stage-slider-wrapper rtl">
                <div className={`title ${this.props.type}`}>
                    כלי נגינה
                </div>
                <div className={`categories-left-arrow ${isMobile() ? 'mobile' : ''}`} onClick={() => this.scrollSubCat('left')}>
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>
                <div className={`categories-right-arrow ${isMobile() ? 'mobile' : ''}`} onClick={() => this.scrollSubCat('right')}>
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>

                <div className="scroller" ref={ref => this.subCatScrollerRef = ref}>
                    {this.renderInstruments()}
                </div>
            </div>
        )
    }
}

PlayingOnStageSlider.propTypes = {
    datatypes: PropTypes.object,
    type: PropTypes.string,
    selected: PropTypes.array,
    selectInstrument: PropTypes.func,
    unSelectInstrument: PropTypes.func,
};

export default PlayingOnStageSlider;



// WEBPACK FOOTER //
// ./src/Components/Elements/Carousels/PlayingOnStageSlider/PlayingOnStageSlider.js